import script from "./consumptionReport.vue?vue&type=script&setup=true&lang=js"
export * from "./consumptionReport.vue?vue&type=script&setup=true&lang=js"

import "./consumptionReport.vue?vue&type=style&index=0&id=5af0ce17&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5af0ce17"]])

export default __exports__